import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Spacer from 'atoms/Spacer'

const mapStateToProps = ({ appSaving }) => ({
  activatorsCount: appSaving.activators.length
})

export default
@connect(mapStateToProps)
class AppSavingIndicator extends Component {
  static propTypes = {
    activatorsCount: PropTypes.number.isRequired,
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.activatorsCount) {
      return { renderedAtleastOnce: true }
    }
    return null
  }

  state = {
    renderedAtleastOnce: false
  }

  render() {
    const { activatorsCount } = this.props
    const { renderedAtleastOnce } = this.state
    let text

    if (activatorsCount) {
      text = 'Saving...'
    } else if (renderedAtleastOnce) {
      text = 'Saved'
    }

    return !!text && (
      <Fragment>
        <Spacer large />
        <Typography>
          <i>{ text }</i>
        </Typography>
      </Fragment>
    )
  }
}
